import { useMemo } from 'react'
import type { TreeNodeData } from '@/components/Elements/tree'
import { useProjectStore } from '@/stores/projectStore'
import { useSettingsSelector } from '@/utils'
import type { ISettings } from '@/utils/settings/settings.interface'

export type BuildingFloorsGroup = NonNullable<
  ISettings['buildingFloorsList']
>[number]

const buildDefaultFloorsList = (nodes: TreeNodeData[]): BuildingFloorsGroup[] => {
  if (!nodes.length) return []

  const roots = nodes.filter((node) => node.parent == null || node.parent === '')
  const hasHierarchy = nodes.some(
    (node) => node.parent != null && node.parent !== '',
  )

  if (!hasHierarchy && roots.length > 0) {
    return [
      {
        name: 'Карта офиса',
        floorIds: roots.map((node) => node.id),
      },
    ]
  }

  return roots.map((root) => {
    const childIds = nodes
      .filter((node) => Number(node.parent) === root.id)
      .map((node) => node.id)

    return {
      name: root.name,
      floorIds: childIds.length ? childIds : [root.id],
    }
  })
}

export function useBuildingFloorsList(): BuildingFloorsGroup[] {
  const configured = useSettingsSelector(
    (settings) => settings.buildingFloorsList,
    [],
  )
  const nodes = useProjectStore((state) => state.nodes)

  return useMemo(() => {
    if (configured?.length) return configured
    return buildDefaultFloorsList(nodes)
  }, [configured, nodes])
}
